import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b710f4ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-left" }
const _hoisted_2 = { class: "title-row" }
const _hoisted_3 = { class: "pool-name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "tooltip-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tags" }
const _hoisted_11 = { class: "tag-icon" }
const _hoisted_12 = { class: "tag-text" }
const _hoisted_13 = { class: "card-main" }
const _hoisted_14 = { class: "content-text" }
const _hoisted_15 = { class: "card-right" }
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card", _ctx.theme]),
    style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          (_ctx.currentPoolNameImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.currentPoolNameImg,
                alt: "产品名称",
                class: "pool-name-img"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.poolName), 1)),
          (_ctx.disclaimer || _ctx.remark)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 2,
                placement: "bottomRight",
                overlayClassName: "tooltipstyle",
                "arrow-point-at-center": ""
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.disclaimer)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.disclaimer), 1))
                      : _createCommentVNode("", true),
                    (_ctx.remark)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.remark), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.helpIconSrc,
                    alt: "?",
                    class: "help-icon"
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags.slice(0, 3), (tag, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "tag"
            }, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getTagIcon()), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(tag), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.content), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("img", {
        src: _ctx.poolIcon,
        alt: "产品图标",
        class: "pool-icon"
      }, null, 8, _hoisted_16)
    ])
  ], 6))
}